import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

const schema = yup
  .object({
    rating: yup.number().required('Seleção obrigatória'),
    name: yup.string().required('Preenchimento obrigatório'),
    email: yup.string().required('Preenchimento obrigatório'),
    title: yup.string().required('Preenchimento obrigatório'),
    city: yup.string().required('Preenchimento obrigatório'),
    comment: yup.string().required('Preenchimento obrigatório'),
    captchaToken: yup.string(),
    images: yup.mixed(),
  })
  .required();

export default yupResolver(schema);
